import React, { useState } from "react";
// import API_Root from "../../Constants/API_Root";
import API_Root from "../../../../Constants/API_Root";
// import { authFetch } from "../../Authentication/authService";
import { authFetch } from "../../../../Authentication/authService";

const TOPIC_OPTIONS = ["service", "technical", "account", "billing", "other"];

const ASSIGNED_OPTIONS = [
  "Himanshu",
  "Ashish",
  "Kartavya",
  "Dilip",
  "Ildiko",
  "Giri",
];

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    feedback: "",
    topic: "technical",
    assigned_to: "Himanshu",
    priority: "low",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {
      const response = await authFetch(
        `https://api-discloseai.essolutions.ai/api/v1/workspace/create-complaint-wrkspc`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            feedback: formData.feedback,
            topic: formData.topic,
            status: "In Progress",
            priority: formData.priority,
            assigned_to: formData.assigned_to,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit feedback.");
      }

      setMessage("✅ Feedback submitted successfully.");

      setFormData({
        feedback: "",
        topic: "technical",
        assigned_to: "Himanshu",
        priority: "low",
      });
    } catch (error) {
      console.error(error);
      setMessage("❌ Failed to submit feedback.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "30px auto",
        padding: "25px",
        background: "#fff",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <h2
        style={{
          marginBottom: "25px",
          color: "#2d3748",
          textAlign: "center",
        }}
      >
        Feedback Form
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Topic */}
        {/* Topic */}
        <div style={{ marginBottom: "18px" }}>
          <label style={labelStyle}>Topic</label>

          <select
            name="topic"
            value={formData.topic}
            onChange={handleChange}
            required
            style={inputStyle}
          >
            {TOPIC_OPTIONS.map((topic) => (
              <option key={topic} value={topic}>
                {topic.charAt(0).toUpperCase() + topic.slice(1)}
              </option>
            ))}
          </select>
        </div>

        {/* Feedback */}
        <div style={{ marginBottom: "18px" }}>
          <label style={labelStyle}>Feedback</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            rows={6}
            placeholder="Enter your feedback..."
            required
            style={{
              ...inputStyle,
              resize: "vertical",
            }}
          />
        </div>

        {/* Assigned To */}
        {/* Assigned To */}
        <div style={{ marginBottom: "18px" }}>
          <label style={labelStyle}>Assigned To</label>

          <select
            name="assigned_to"
            value={formData.assigned_to}
            onChange={handleChange}
            required
            style={inputStyle}
          >
            {ASSIGNED_OPTIONS.map((person) => (
              <option key={person} value={person}>
                {person}
              </option>
            ))}
          </select>
        </div>

        {/* Priority */}
        <div style={{ marginBottom: "25px" }}>
          <label style={labelStyle}>Priority</label>
          <select
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            background: "#3E826D",
            color: "#fff",
            border: "none",
            padding: "12px",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Submitting..." : "Submit Feedback"}
        </button>

        {message && (
          <div
            style={{
              marginTop: "18px",
              textAlign: "center",
              fontWeight: 600,
            }}
          >
            {message}
          </div>
        )}
      </form>
    </div>
  );
};

const labelStyle = {
  display: "block",
  marginBottom: "8px",
  fontWeight: "600",
  color: "#444",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  border: "1px solid #dcdcdc",
  borderRadius: "6px",
  fontSize: "15px",
  outline: "none",
  boxSizing: "border-box",
};

export default FeedbackForm;
